import React, { Fragment, useEffect, useState } from 'react';
import './styles.scss';
import { getBrands } from 'utils/firebase';
import InventoryBrand from 'components/kitchen/inventory-brand';
import ExportInventoryModal from 'components/cs/modals/export-inventory-modal';
import { ReactComponent as FolderDownloadIcon } from 'assets/icons/folder-download.svg';
import { BrandType } from 'models/brand.model';
import BreadCrumbs from 'components/kitchen/breadcrumbs';
import { Dropdown, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { STORAGE_KEYS } from 'utils/constants';

const KitchenInventory = () => {
  const [allBrandsArray, setAllBrandsArray] = useState<BrandType[]>([]);
  const [brandsArray, setBrandsArray] = useState<BrandType[]>([]);
  const [selectedBrand, setSelectedBrand] = useState('');
  const [searchValue] = useState('');
  const [filters, setFilters] = useState(
    [] as { key: string; title: string; number: number; active: boolean }[]
  );
  const [loading, setLoading] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [brandOptions, setBrandOptions] = useState<{ value: string; text: string }[]>([]);
  const [filteredBrands, setFilteredBrands] = useState<BrandType[]>([]);
  const [workHours, setWorkHours] = useState([]);

  useEffect(() => {
    setLoading(true);
    loadData();
  }, []);

  useEffect(() => {
    const COKITCHEN_ID = localStorage.getItem(STORAGE_KEYS.COKITCHEN);
    const filtersArr: { key: string; title: string; number: number; active: boolean }[] = [];
    brandsArray
      ?.filter((item) => item.cokitchen_id === COKITCHEN_ID)
      ?.forEach((brand, index) => {
        if (index === 0 && selectedBrand === '') onFilterClick({ key: brand.id });
        const meal_categories = brand.meal_categories && JSON.parse(brand?.meal_categories);
        filtersArr.push({
          key: brand.id,
          title: brand.name,
          number: meal_categories?.length,
          active: brand.id === selectedBrand
        });
      });
    setFilters(filtersArr);
    const filteredBrand = brandsArray?.filter((item) => item.id === selectedBrand);
    setFilteredBrands(filteredBrand);
    setAllBrandsArray(brandsArray);
  }, [selectedBrand, brandsArray]);

  useEffect(() => {
    const optionsArr: { value: string; text: string }[] = [{ text: 'All', value: 'all' }];
    allBrandsArray?.forEach((brand) => {
      optionsArr.push({
        value: brand.id,
        text: brand.name
      });
    });
    setBrandOptions(optionsArr);
  }, [allBrandsArray]);
  useEffect(() => {
    const optionsArr: { value: string; text: string }[] = [{ text: 'All', value: 'all' }];
    allBrandsArray?.forEach((brand) => {
      optionsArr.push({
        value: brand.id,
        text: brand.name
      });
    });
    setBrandOptions(optionsArr);
  }, [allBrandsArray]);

  const reduceMealCategories = (acc: any, { name, ...others }: { name: string }) => {
    const lowerName = name?.toLowerCase();
    if (lowerName.includes(searchValue.toLowerCase())) acc.push({ name, ...others });
    return acc;
  };

  const reduceBrandArray = (acc: any, { meal_categories: categories, ...brand }: any) => {
    const meal_categories = categories.reduce(reduceMealCategories, []);
    if (meal_categories.length > 0) acc.push({ ...brand, meal_categories });
    return acc;
  };

  useEffect(() => {
    if (searchValue === '') {
      setBrandsArray([...allBrandsArray]);
      return;
    }
    const matches = allBrandsArray.reduce(reduceBrandArray, []);
    setBrandsArray(matches);
  }, [searchValue]);

  const onFilterClick = (filter: any) => {
    setSelectedBrand(filter.key);
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const brands: BrandType[] = await getBrands();
      setBrandsArray(brands);
    } catch {
      toast(<ToastMessage type='error' message='Error loading meals' />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const workingHours = filteredBrands?.[0]?.brand_working_hours?.map((item: any) => {
      return {
        day: item.name,
        opening_time: item.opening_time
      };
    });
    setWorkHours(workingHours);
  }, [filteredBrands]);

  return (
    <div>
      {!loading && filteredBrands.length === 0 ? (
        <p>Reload page to fetch data</p>
      ) : (
        <Fragment>
          <BreadCrumbs filters={filters} onFilterClick={onFilterClick} searchValue={searchValue} />

          <Fragment>
            <div className='grow flex gap-4 object-contain whitespace-nowrap overflow-x-auto pr-24'>
              {filteredBrands?.map((brand) => (
                <InventoryBrand
                  key={brand?.id}
                  mealCategories={brand?.meal_categories}
                  onReloadData={loadData}
                  brandId={brand.id}
                  brandName={brand.name}
                  workingHours={workHours}
                />
              ))}
            </div>
            <div className='fixed bottom-[11rem] right-[3rem] z-10'>
              <Dropdown
                tooltip
                interactive
                arrow
                content={
                  <div
                    className='cursor-pointer p-[14px] bg-red-5 rounded-full shadow-lg shadow-[#5b5a5a]'
                    onClick={() => setShowExportModal(true)}>
                    <FolderDownloadIcon className='text-white w-9 h-9' />
                  </div>
                }>
                <div className='bg-white p-4 shadow-lg rounded-lg min-w-[300px]'>
                  Download inventory to view items you have in stock. lorem ipssum dulom, dummy text
                  to fill space later.
                </div>
              </Dropdown>
            </div>
            {showExportModal && (
              <ExportInventoryModal
                show
                onClose={() => setShowExportModal(false)}
                options={brandOptions}
              />
            )}
          </Fragment>
        </Fragment>
      )}
    </div>
  );
};

export default KitchenInventory;
